module.exports = __webpack_public_path__ + "img/canada-other-heart-diseases-female.27182007.png";